import { useQueryClient, useQuery, useMutation } from "react-query";
import {
  fetchRegionSettings,
  fetchAllRegionSettings,
  updateRegionSettings,
  RegionSettings,
} from "../api/regionSettings";

const SETTINGS_STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const useFetchRegionSettings = () => {
  return useQuery(["regionSettings"], fetchRegionSettings, {
    staleTime: SETTINGS_STALE_TIME,
    retry: 1,
  });
};

export const useFetchAllRegionSettings = () => {
  return useQuery(["regionSettings", "all"], fetchAllRegionSettings, {
    staleTime: SETTINGS_STALE_TIME,
  });
};

export const useUpdateRegionSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ region, settings }: { region: string; settings: Partial<RegionSettings> }) =>
      updateRegionSettings(region, settings),
    {
      onSettled: () => {
        queryClient.invalidateQueries("regionSettings");
      },
    }
  );
};
